import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-120fcd7a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "register-form"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "register-head"
}, "用户注册", -1));

const _hoisted_3 = {
  class: "organ-icon"
};
const _hoisted_4 = {
  class: "code-text"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("获取验证码");

const _hoisted_6 = {
  class: "agree-tip"
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode("    ");

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [/*#__PURE__*/_createTextVNode(" 我同意 "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.zhihuishu.com/user/protocal.html",
  target: "_blank",
  class: "link-unit"
}, " 《用户服务协议》 "), /*#__PURE__*/_createTextVNode(" 和 "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.zhihuishu.com/columnsapp/student/UserPrivacyProtocol/PrivacyPolicy1.html",
  target: "_blank",
  class: "link-unit"
}, " 《隐私政策》 ")], -1));

const _hoisted_9 = /*#__PURE__*/_createTextVNode("注册并登录");

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已有账号？", -1));

import { phoneRegExp, passwordRegExp } from '@/plugins/RegExp.js';
import useCommon from '@/hooks/useCommon.ts';
import Captcha from '@/components/Captcha/index.vue';
import { setCookie } from '@/plugins/utils';
export default {
  emits: ['handleClose'],

  setup(__props, {
    emit
  }) {
    const {
      basicSendSms,
      validateRegisterCode,
      confirmRegisterCode,
      getLogin
    } = inject('$http');
    const formRef = ref();
    const form = reactive({
      userName: '',
      orgId: '',
      mobile: '',
      code: '',
      password: '',
      agreeCheck: true
    }); // 机构

    const organProps = {
      value: 'id',
      label: 'organName',
      checkStrictly: true,
      emitPath: false
    };
    const {
      orgList,
      getOrgList
    } = useCommon();
    getOrgList(); // 校验手机号

    const validPhoneNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入您的手机号'));
      } else if (!phoneRegExp.test(value)) {
        callback(new Error('手机号码格式不正确'));
      } else {
        callback();
      }
    };

    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (!passwordRegExp.test(value)) {
        callback(new Error('请输入8-16位密码(大小写字母+数字)'));
      } else {
        callback();
      }
    };

    const validateAgreeCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请先勾选协议'));
      } else {
        callback();
      }
    };

    const registerRules = {
      userName: [{
        required: true,
        trigger: 'blur',
        message: '请输入您的名字'
      }],
      orgId: [{
        required: true,
        trigger: 'change',
        message: '请选择机构'
      }],
      mobile: [{
        required: true,
        trigger: 'blur',
        validator: validPhoneNumber
      }],
      code: [{
        required: true,
        trigger: 'blur',
        message: '请输入验证码'
      }, {
        min: 4,
        max: 4,
        message: '请输入四位验证码',
        trigger: 'blur'
      }],
      password: [{
        required: true,
        trigger: 'blur',
        validator: validatePass
      }],
      agreeCheck: [{
        required: true,
        trigger: 'change',
        validator: validateAgreeCheck
      }]
    }; // 发送验证码

    const codeShow = ref(true);
    const count = ref(0);
    const CaptchaEl = ref();

    const getCode = () => {
      if (!form.mobile) {
        ElMessage.warning('请先输入您的手机号码');
        return;
      }

      if (phoneRegExp.test(form.mobile)) {
        CaptchaEl.value.show();
      } else {
        ElMessage.warning('手机号码格式不正确');
        return;
      }
    }; // 滑块验证成功发送


    const captchaSuccess = async ({
      randstr: randStr,
      ticket
    }) => {
      let params = {
        mobile: form.mobile,
        randStr,
        ticket
      };
      await basicSendSms(params);
      countdown(60);
    }; // 创建一个倒计时函数，参数为倒计时时间（单位：秒）


    function countdown(seconds) {
      codeShow.value = false;
      count.value = seconds; // 定义一个倒计时器

      const intervalId = setInterval(() => {
        // 每秒执行一次，更新显示并检查是否到零
        console.log(`剩余时间：${count.value} 秒`);
        count.value--; // 倒计时结束，清除定时器

        if (count.value < 0) {
          clearInterval(intervalId);
          console.log('倒计时结束！');
          codeShow.value = true;
        }
      }, 1000); // 每隔1000毫秒执行一次（即每秒执行一次）
      // 启动倒计时

      console.log(`倒计时开始，计时 ${seconds} 秒...`);
    }

    const confirmRegister = () => {
      formRef.value.validate(async valid => {
        if (valid) {
          // 校验验证码
          const res = await validateRegisterCode({
            code: form.code,
            mobile: form.mobile
          });

          if (res) {
            // 注册
            const result = await confirmRegisterCode(form);

            if (result) {
              // 登录
              let params = {
                password: form.password,
                username: form.mobile,
                logInType: 1
              };
              const {
                token
              } = await getLogin(params, {
                headers: {
                  'Content-Type': 'application/json'
                }
              });
              setCookie('X-Access-Token', token);
              window.location.href = `/index.html`;
            }
          }
        }
      });
    };

    const goLogin = () => {
      emit('handleClose');
    };

    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_cascader = _resolveComponent("el-cascader");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: _unref(form),
        rules: registerRules,
        "auto-complete": "on"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          class: "login-item",
          prop: "userName"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "请输入您的真实姓名",
            modelValue: _unref(form).userName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).userName = $event),
            maxlength: "11"
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              icon: "姓名",
              "class-name": "register-icon"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "login-item",
          prop: "orgId"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_cascader, {
            modelValue: _unref(form).orgId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).orgId = $event),
            options: _unref(orgList),
            props: organProps,
            clearable: "",
            filterable: "",
            placeholder: "请选择您的所属机构",
            "show-all-levels": false,
            style: {
              "width": "100%"
            }
          }, null, 8, ["modelValue", "options"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_svg_icon, {
            icon: "机构"
          })])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "login-item",
          prop: "mobile"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            placeholder: "请输入您的手机号码",
            modelValue: _unref(form).mobile,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).mobile = $event),
            maxlength: "11"
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              icon: "手机号",
              "class-name": "register-icon"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "login-item",
          prop: "code"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).code,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(form).code = $event),
            placeholder: "请输入您的手机验证码",
            autocomplete: "off",
            maxlength: "4"
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              icon: "验证码",
              "class-name": "register-icon"
            })]),
            suffix: _withCtx(() => [_createElementVNode("div", _hoisted_4, [codeShow.value ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "code-get",
              type: "text",
              onClick: _cache[3] || (_cache[3] = $event => getCode())
            }, {
              default: _withCtx(() => [_hoisted_5]),
              _: 1
            })) : _createCommentVNode("", true), !codeShow.value ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              class: "code-get",
              type: "text"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(count.value) + "秒后重新发送", 1)]),
              _: 1
            })) : _createCommentVNode("", true)])]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "login-item",
          prop: "password"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).password,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).password = $event),
            type: "password",
            autocomplete: "new-password",
            placeholder: "8~16位大小写字母+数字密码"
          }, {
            prefix: _withCtx(() => [_createVNode(_component_svg_icon, {
              icon: "密码",
              "class-name": "register-icon"
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "login-item",
          prop: "agreeCheck"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_checkbox, {
            modelValue: _unref(form).agreeCheck,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(form).agreeCheck = $event)
          }, null, 8, ["modelValue"]), _hoisted_7, _hoisted_8])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_button, {
        class: "register-btn",
        type: "primary",
        onClick: confirmRegister
      }, {
        default: _withCtx(() => [_hoisted_9]),
        _: 1
      }), _createElementVNode("div", {
        class: "login-tip"
      }, [_hoisted_10, _createElementVNode("span", {
        class: "link-unit",
        onClick: goLogin
      }, "立即登录")])]), _createVNode(Captcha, {
        ref_key: "CaptchaEl",
        ref: CaptchaEl,
        onSuccess: captchaSuccess
      }, null, 512)], 64);
    };
  }

};